/**
 * Chat Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    var user = require('user');
    var config = require('config');
    var ChatView = require('replacers/chat/chat.view');

    module.exports = ChatView.extend({

        render: function() {
            var shouldHideButton = !config.get('chatWidget') || this.options.name === 'CHAT_BUTTON' && !config.get('chatWidget').showIcon;
            var isSubscriptionNeeded = !this.subscribed && config.get('chatWidget') && config.get('chatWidget').enabled;

            if (shouldHideButton) {
                return this;
            } else if (isSubscriptionNeeded) {
                this.subscribeToApiEvents();
            } else {
                this.$el.html(this.tmpl(this.options.name.toLowerCase(), {
                    unreadCount: this.api('getUnreadCount').adminMessagesCount,
                    isAdminAvailable: this.api('getAdminStatus').isAdminAvailable,
                    isLoggedIn: user.isLoggedIn()
                }));
            }

            return this;
        }
    });
});
